const POSITION_LIMITS = {
  tshirt: { x: [-1, 1], y: [-1, 1] },

  mug: { x: [-0.5, 1.0], y: [-0.5, 0.9] },

  coffee: { x: [-0.5, 0.5], y: [0.4, 1.2] },

  tumbler: { x: [-0.5, 0.5], y: [0.5, 1.4] },

  book: { x: [-0.6, 0.6], y: [0.8, 1.4] },

  box: { x: [-0.6, 0.6], y: [0.6, 1.4] },
};

/* ===================================================== */

export function XYControls({ transform, setPosition, product }) {
  const limits = POSITION_LIMITS[product] ?? POSITION_LIMITS.tshirt;

  /*
    clamp 안전성
  */

  function clamp(value, min, max) {
    return Math.min(Math.max(value, min), max);
  }

  function handleChange(axis, rawValue) {
    const value = parseFloat(rawValue);

    const [min, max] = limits[axis];

    const safeValue = clamp(value, min, max);

    setPosition({
      ...transform.position,

      [axis]: safeValue,
    });
  }

  return (
    <div className='flex flex-col gap-4'>
      <Label>Position</Label>

      <AxisRow
        label='X'
        value={transform.position.x}
        min={limits.x[0]}
        max={limits.x[1]}
        onChange={(v) => handleChange('x', v)}
      />

      <AxisRow
        label='Y'
        value={transform.position.y}
        min={limits.y[0]}
        max={limits.y[1]}
        onChange={(v) => handleChange('y', v)}
      />
    </div>
  );
}

/* ===================================================== */

function AxisRow({ label, value, min, max, onChange }) {
  return (
    <div className='flex items-center gap-3'>
      {/* axis label */}

      <span
        className='
          w-5
          text-xs
          font-medium
          text-[#8A867F]
        '
      >
        {label}
      </span>

      {/* slider */}

      <input
        type='range'
        min={min}
        max={max}
        step={0.01}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className='
          flex-1
          h-[3px]
          bg-[#E7E2D9]
          rounded-full
          appearance-none
          cursor-pointer

          accent-[#C6A75E]
        '
      />

      {/* value */}

      <span
        className='
          w-12
          text-[11px]
          font-medium
          text-[#1F1F1F]
          text-right
          tabular-nums
        '
      >
        {value.toFixed(2)}
      </span>
    </div>
  );
}

/* ===================================================== */

function Label({ children }) {
  return (
    <div
      className='
        text-[11px]
        font-semibold
        text-[#8A867F]
        uppercase
        tracking-widest
      '
    >
      {children}
    </div>
  );
}
